import { render, staticRenderFns } from "./APlataformaAsig.vue?vue&type=template&id=e3115532"
import script from "./APlataformaAsig.vue?vue&type=script&lang=js"
export * from "./APlataformaAsig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports